var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "20", height: "20", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
    React.createElement(
      "defs",
      null,
      React.createElement("path", { d: "M9 18A9 9 0 1 1 9 0a9 9 0 0 1 0 18zm0-1.636A7.364 7.364 0 1 0 9 1.636a7.364 7.364 0 0 0 0 14.728zM6.107 8.76l1.736 1.736 4.05-4.05a.818.818 0 1 1 1.157 1.157L8.42 12.232a.818.818 0 0 1-1.157 0L4.95 9.917A.818.818 0 1 1 6.107 8.76z", id: "svg2694640254a" })
    ),
    React.createElement(
      "g",
      { transform: "translate(1 1)", fill: "none", fillRule: "evenodd" },
      React.createElement(
        "mask",
        { id: "svg2694640254b", fill: "#fff" },
        React.createElement("use", { xlinkHref: "#svg2694640254a" })
      ),
      React.createElement("use", { fillRule: "nonzero", xlinkHref: "#svg2694640254a" }),
      React.createElement(
        "g",
        { mask: "url(#svg2694640254b)", fill: "currentColor" },
        React.createElement("path", { d: "M-1-1h20v20H-1z" })
      )
    )
  );
});